import { ActivatedRoute } from '@angular/router';
import { FieldsAgricolaService } from '../../../../../../Services/agricola/fields.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import {
  GlobalFunction,
  customOptions,
} from '../../../../../../Services/public/globalFunction';
import { Subscription } from 'rxjs';
import { FieldSectorService } from '../../../services/sectors.service';
import { Incidence, Report } from '../../../interfaces/reports.interface';
import { ReportsService } from '../../../services/reports.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportViewComponent implements OnInit {
  @ViewChild('audioOption') audioPlayerRef: ElementRef;
  @ViewChild('ImageViewer') public ImageViewer;

  selectedImage: any = '';

  customOptions = customOptions;

  report: Report | null;

  video: any = [];
  audios: any = [];

  agriculturalIncidence: any = [];
  tecnicaIncidence: any = [];

  sector: any = null;
  sectorMapData: any = null;
  reportID: string = '';

  reportSuscription: Subscription | undefined;

  constructor(
    public fieldsService: FieldsAgricolaService,
    public reportService: ReportsService,
    public globalFunction: GlobalFunction,
    public route: ActivatedRoute,
    public router: Location,
    public fieldSectorService: FieldSectorService
  ) {}
  ngOnDestroy() {
    if (this.reportSuscription) {
      this.reportSuscription.unsubscribe();
    }
  }
  ngOnInit() {
    this.reportSuscription = this.reportService.reportObservable$.subscribe(
      (report) => {
        console.log('se obtuvo el reporte', report);
        this.report = report;

        if (report && report.incidences.length > 0) {
          this.report.incidences[0].selected = true;
          this.selectedIncidence = this.report.incidences[0];
        }
      }
    );
  }

  goRequisitions() {
    this.globalFunction.goRequisitions('report', Number(this.reportID));
  }

  selectedIncidence: Incidence | null = null;

  selectIncidence(incidence, idx) {
    this.report.incidences = this.report.incidences.map((item) => {
      return { ...item, selected: false };
    });
    this.report.incidences[idx].selected = true;

    this.selectedIncidence = { ...incidence, selected: true };
  }

  async openImageViewer(url: string) {
    this.selectedImage = url;
    this.globalFunction.Modal(this.ImageViewer, 'show', { size: 'xl' });
  }
}
